// block icon.
export const HorizontalBlockIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 512 512">
		<defs>
			<style>{ '.st1{fill:#f26c0d}' }</style>
		</defs>
		<path
			d="M127.3 217.3c12.6.2 25.2 0 37.8 0s25.2.1 37.8 0c15.1-.2 27.8-11.6 30-26.6 2.2-15.1-7-29.6-21.7-33.9-2.5-.7-3.3-1.7-3.8-4.3-2.7-15.8-15.5-27.8-31.7-30.1-15.2-2.1-30.7 6.1-37.8 20.3-.4.9-.8 1.1-1.8.8-13.6-3.4-26 9-22.4 22.4.3 1.2 0 1.6-.9 2.3-9.3 6.5-13.5 15.4-11.8 26.6 2 13.1 12.9 22.3 26.1 22.5ZM205.2 230.8l-10.6 10.6c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8-3-3-7.8-3-10.8 0ZM166.9 230.8l-10.6 10.6c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8s-7.8-3-10.8 0ZM128.6 230.8 118 241.4c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8-3-3-7.8-3-10.8 0ZM281.7 174.6H394c9.5 0 17.2-7.7 17.2-17.2s-7.7-17.2-17.2-17.2H281.7c-9.5 0-17.2 7.7-17.2 17.2s7.7 17.2 17.2 17.2ZM281.7 236.3H394c9.5 0 17.2-7.7 17.2-17.2s-7.7-17.2-17.2-17.2H281.7c-9.5 0-17.2 7.7-17.2 17.2s7.7 17.2 17.2 17.2Z"
			className="st1"
		/>
		<path
			d="M448 43.5H64c-34.5 0-62.5 28-62.5 62.5v300c0 34.5 28 62.5 62.5 62.5h384c34.5 0 62.5-28 62.5-62.5V106c0-34.5-28-62.5-62.5-62.5ZM465.5 406c0 9.6-7.9 17.5-17.5 17.5H64c-9.6 0-17.5-7.9-17.5-17.5V106c0-9.6 7.9-17.5 17.5-17.5h384c9.6 0 17.5 7.9 17.5 17.5v300Z"
			className="st1"
		/>
		<path
			d="M383.4 310.5c-5.4 4.5-10.7 9.6-15.8 14.5-5.5 5.3-14.1 13.5-19.2 16.7-3.8-3.2-9.6-9.3-13.4-13.3-13.9-14.6-25.8-27.2-40.8-27.2s-26.6 10.1-40.1 20.7c-4.8 3.7-12.2 9.6-16.6 12-4.1-3.1-10.6-10.2-14.9-14.7-12.8-13.7-23.8-25.5-37.9-25.5s-32.8 13.6-67.3 46.5c-3.7 3.5-7.6 7.3-11.8 11.3-7.2 6.9-7.5 18.2-.6 25.4 3.5 3.7 8.3 5.6 13 5.6s8.9-1.6 12.4-5c4.2-4 8.2-7.8 11.9-11.4 17.2-16.4 33.5-32.1 40.7-35.8 3.6 3 9.5 9.3 13.3 13.3 13 13.9 25.2 27 40.4 27s26.2-10 39.7-20.5c4.9-3.8 12.5-9.8 17-12.2 4.2 3.2 11.2 10.5 15.6 15.2 13 13.7 24.3 25.5 38.1 25.5s30.5-13.5 45.4-27.8c4.9-4.7 9.5-9.1 13.9-12.7 7.7-6.3 8.7-17.7 2.4-25.3-6.3-7.7-17.7-8.7-25.3-2.4Z"
			className="st1"
		/>
	</svg>
);
export const HorizontalPreview = () => (
	<svg viewBox="0 0 236 158" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			fill="white"
		/>
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			stroke="#9EA9B2"
			strokeWidth={ 1.5 }
		/>
		<path
			d="M20 30.8C20 27.123 20 25.2846 21.1423 24.1423C22.2846 23 24.123 23 27.8 23H207.2C210.877 23 212.715 23 213.858 24.1423C215 25.2846 215 27.123 215 30.8V127.2C215 130.877 215 132.715 213.858 133.858C212.715 135 210.877 135 207.2 135H27.8C24.123 135 22.2846 135 21.1423 133.858C20 132.715 20 130.877 20 127.2V30.8Z"
			fill="white"
		/>
		<path
			d="M207.2 134L207.2 135H27.8L27.7998 134H207.2ZM214 127.2V30.7998C214 28.9334 213.998 27.6341 213.866 26.6543C213.738 25.7032 213.505 25.204 213.15 24.8496C212.796 24.4952 212.297 24.2617 211.346 24.1338C210.366 24.0021 209.067 24 207.2 24H27.7998C25.9334 24 24.6341 24.0021 23.6543 24.1338C22.7032 24.2617 22.204 24.4952 21.8496 24.8496C21.4952 25.204 21.2617 25.7032 21.1338 26.6543C21.035 27.3891 21.0087 28.3035 21.002 29.502L21 30.7998V127.2C21 129.067 21.0021 130.366 21.1338 131.346C21.2617 132.297 21.4952 132.796 21.8496 133.15C22.204 133.505 22.7032 133.738 23.6543 133.866C24.6341 133.998 25.9334 134 27.7998 134L27.8 135C24.238 135 22.4008 135 21.251 133.962L21.1423 133.858C20.1428 132.858 20.0176 131.326 20.002 128.495L20 127.2V30.8C20 27.238 19.9996 25.4008 21.0381 24.251L21.1423 24.1423C22.2846 23 24.123 23 27.8 23H207.2L208.495 23.002C211.326 23.0176 212.858 23.1428 213.858 24.1423C215 25.2846 215 27.123 215 30.8V127.2L214.998 128.495C214.982 131.326 214.857 132.858 213.858 133.858C212.858 134.857 211.326 134.982 208.495 134.998L207.2 135L207.2 134C209.067 134 210.366 133.998 211.346 133.866C212.297 133.738 212.796 133.505 213.15 133.15C213.505 132.796 213.738 132.297 213.866 131.346C213.998 130.366 214 129.067 214 127.2Z"
			fill="#58707F"
		/>
		<path
			d="M117.5 34.033C117.5 33.2252 118.155 32.5705 118.962 32.5705H129.687C130.495 32.5705 131.15 33.2252 131.15 34.033C131.15 34.8407 130.495 35.4955 129.687 35.4955H118.962C118.155 35.4955 117.5 34.8407 117.5 34.033Z"
			fill="#58707F"
		/>
		<path
			d="M133.1 34.033C133.1 33.2252 133.755 32.5705 134.562 32.5705H143.337C144.145 32.5705 144.8 33.2252 144.8 34.033C144.8 34.8407 144.145 35.4955 143.337 35.4955H134.562C133.755 35.4955 133.1 34.8407 133.1 34.033Z"
			fill="#58707F"
		/>
		<path
			d="M117.5 42.5642C117.5 41.7565 118.155 41.1017 118.962 41.1017H129.687C130.495 41.1017 131.15 41.7565 131.15 42.5642C131.15 43.3719 130.495 44.0267 129.687 44.0267H118.962C118.155 44.0267 117.5 43.3719 117.5 42.5642Z"
			fill="#58707F"
		/>
		<path
			d="M133.1 42.5642C133.1 41.7565 133.755 41.1017 134.562 41.1017H155.037C155.845 41.1017 156.5 41.7565 156.5 42.5642C156.5 43.3719 155.845 44.0267 155.037 44.0267H134.562C133.755 44.0267 133.1 43.3719 133.1 42.5642Z"
			fill="#58707F"
		/>
		<path
			d="M117.5 51.0955C117.5 50.2878 118.155 49.633 118.962 49.633H129.687C130.495 49.633 131.15 50.2878 131.15 51.0955C131.15 51.9032 130.495 52.558 129.687 52.558H118.962C118.155 52.558 117.5 51.9032 117.5 51.0955Z"
			fill="#58707F"
		/>
		<path
			d="M133.1 51.0955C133.1 50.2878 133.755 49.633 134.562 49.633H147.237C148.045 49.633 148.7 50.2878 148.7 51.0955C148.7 51.9032 148.045 52.558 147.237 52.558H134.562C133.755 52.558 133.1 51.9032 133.1 51.0955Z"
			fill="#58707F"
		/>
		<path
			d="M117.5 59.6267C117.5 58.819 118.155 58.1642 118.962 58.1642H129.687C130.495 58.1642 131.15 58.819 131.15 59.6267C131.15 60.4344 130.495 61.0892 129.687 61.0892H118.962C118.155 61.0892 117.5 60.4344 117.5 59.6267Z"
			fill="#58707F"
		/>
		<path
			d="M133.1 59.6267C133.1 58.819 133.755 58.1642 134.562 58.1642H145.287C146.095 58.1642 146.75 58.819 146.75 59.6267C146.75 60.4344 146.095 61.0892 145.287 61.0892H134.562C133.755 61.0892 133.1 60.4344 133.1 59.6267Z"
			fill="#58707F"
		/>
		<path
			d="M117.5 68.158C117.5 67.3503 118.155 66.6955 118.962 66.6955H129.687C130.495 66.6955 131.15 67.3503 131.15 68.158C131.15 68.9657 130.495 69.6205 129.687 69.6205H118.962C118.155 69.6205 117.5 68.9657 117.5 68.158Z"
			fill="#58707F"
		/>
		<path
			d="M133.1 68.158C133.1 67.3502 133.755 66.6955 134.562 66.6955H153.087C153.895 66.6955 154.55 67.3502 154.55 68.158C154.55 68.9657 153.895 69.6205 153.087 69.6205H134.562C133.755 69.6205 133.1 68.9657 133.1 68.158Z"
			fill="#58707F"
		/>
		<path
			d="M166.25 34.033C166.25 33.2252 166.905 32.5705 167.712 32.5705H178.437C179.245 32.5705 179.9 33.2252 179.9 34.033C179.9 34.8407 179.245 35.4955 178.437 35.4955H167.712C166.905 35.4955 166.25 34.8407 166.25 34.033Z"
			fill="#58707F"
		/>
		<path
			d="M181.85 34.033C181.85 33.2252 182.505 32.5705 183.312 32.5705H192.087C192.895 32.5705 193.55 33.2252 193.55 34.033C193.55 34.8407 192.895 35.4955 192.087 35.4955H183.312C182.505 35.4955 181.85 34.8407 181.85 34.033Z"
			fill="#58707F"
		/>
		<path
			d="M166.25 42.5642C166.25 41.7565 166.905 41.1017 167.712 41.1017H178.437C179.245 41.1017 179.9 41.7565 179.9 42.5642C179.9 43.3719 179.245 44.0267 178.437 44.0267H167.712C166.905 44.0267 166.25 43.3719 166.25 42.5642Z"
			fill="#58707F"
		/>
		<path
			d="M181.85 42.5642C181.85 41.7565 182.505 41.1017 183.312 41.1017H203.787C204.595 41.1017 205.25 41.7565 205.25 42.5642C205.25 43.3719 204.595 44.0267 203.787 44.0267H183.312C182.505 44.0267 181.85 43.3719 181.85 42.5642Z"
			fill="#58707F"
		/>
		<path
			d="M166.25 51.0955C166.25 50.2878 166.905 49.633 167.712 49.633H178.437C179.245 49.633 179.9 50.2878 179.9 51.0955C179.9 51.9032 179.245 52.558 178.437 52.558H167.712C166.905 52.558 166.25 51.9032 166.25 51.0955Z"
			fill="#58707F"
		/>
		<path
			d="M181.85 51.0955C181.85 50.2878 182.505 49.633 183.312 49.633H195.987C196.795 49.633 197.45 50.2878 197.45 51.0955C197.45 51.9032 196.795 52.558 195.987 52.558H183.312C182.505 52.558 181.85 51.9032 181.85 51.0955Z"
			fill="#58707F"
		/>
		<path
			d="M166.25 59.6267C166.25 58.819 166.905 58.1642 167.712 58.1642H178.437C179.245 58.1642 179.9 58.819 179.9 59.6267C179.9 60.4344 179.245 61.0892 178.437 61.0892H167.712C166.905 61.0892 166.25 60.4344 166.25 59.6267Z"
			fill="#58707F"
		/>
		<path
			d="M181.85 59.6267C181.85 58.819 182.505 58.1642 183.312 58.1642H194.037C194.845 58.1642 195.5 58.819 195.5 59.6267C195.5 60.4344 194.845 61.0892 194.037 61.0892H183.312C182.505 61.0892 181.85 60.4344 181.85 59.6267Z"
			fill="#58707F"
		/>
		<path
			d="M166.25 68.158C166.25 67.3503 166.905 66.6955 167.712 66.6955H178.437C179.245 66.6955 179.9 67.3503 179.9 68.158C179.9 68.9657 179.245 69.6205 178.437 69.6205H167.712C166.905 69.6205 166.25 68.9657 166.25 68.158Z"
			fill="#58707F"
		/>
		<path
			d="M181.85 68.158C181.85 67.3502 182.505 66.6955 183.312 66.6955H201.837C202.645 66.6955 203.3 67.3502 203.3 68.158C203.3 68.9657 202.645 69.6205 201.837 69.6205H183.312C182.505 69.6205 181.85 68.9657 181.85 68.158Z"
			fill="#58707F"
		/>
		<path
			d="M30.25 77.4205C30.25 76.3435 31.123 75.4705 32.2 75.4705H47.8C48.8769 75.4705 49.75 76.3435 49.75 77.4205C49.75 78.4974 48.8769 79.3705 47.8 79.3705H32.2C31.123 79.3705 30.25 78.4974 30.25 77.4205Z"
			fill="#58707F"
		/>
		<path
			d="M53.65 77.4205C53.65 76.3436 54.523 75.4705 55.6 75.4705H71.2C72.2769 75.4705 73.15 76.3436 73.15 77.4205C73.15 78.4975 72.2769 79.3705 71.2 79.3705H55.6C54.523 79.3705 53.65 78.4975 53.65 77.4205Z"
			fill="#ABB6BD"
		/>
		<path
			d="M77.05 77.4205C77.05 76.3436 77.923 75.4705 79 75.4705H94.6C95.6769 75.4705 96.55 76.3436 96.55 77.4205C96.55 78.4975 95.6769 79.3705 94.6 79.3705H79C77.923 79.3705 77.05 78.4975 77.05 77.4205Z"
			fill="#ABB6BD"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M30.25 91.3789C30.25 91.3789 46.9122 89.0462 55.3215 89.4985C60.6939 89.7875 73.1492 94.5823 85.7653 94.5128C98.373 94.4433 107.184 89.2799 119.791 89.1404C130.304 89.024 137.932 92.5191 148.444 92.722C160.413 92.953 166.918 90.2206 178.888 90.0358C189.47 89.8723 205.75 93.6174 205.75 93.6174V99.1689C205.75 100.857 205.75 101.702 205.226 102.226C204.701 102.751 203.857 102.751 202.168 102.751H33.8317C32.1433 102.751 31.2991 102.751 30.7745 102.226C30.25 101.702 30.25 100.857 30.25 99.1689V91.3789Z"
			fill="#58707F"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M30.25 92.6075C30.25 92.6075 46.9122 90.2748 55.3214 90.7272C60.9577 91.0304 73.1491 95.811 85.7653 95.7415C98.3729 95.672 106.487 90.6181 119.791 90.369C129.605 90.1852 137.932 93.7477 148.444 93.9506C160.413 94.1816 166.918 91.4492 178.888 91.2643C189.47 91.1009 205.75 94.846 205.75 94.846V103.979H30.25V92.6075Z"
			fill="#DEE2E5"
		/>
		<path
			d="M58.33 90.154C58.33 91.6079 57.1514 92.7865 55.6975 92.7865C54.2436 92.7865 53.065 91.6079 53.065 90.154C53.065 88.7001 54.2436 87.5215 55.6975 87.5215C57.1514 87.5215 58.33 88.7001 58.33 90.154Z"
			fill="#58707F"
		/>
		<path
			d="M89.92 95.068C89.92 96.5219 88.7414 97.7005 87.2875 97.7005C85.8336 97.7005 84.655 96.5219 84.655 95.068C84.655 93.6141 85.8336 92.4355 87.2875 92.4355C88.7414 92.4355 89.92 93.6141 89.92 95.068Z"
			fill="#58707F"
		/>
		<path
			d="M119.755 89.803C119.755 91.2569 118.576 92.4355 117.122 92.4355C115.669 92.4355 114.49 91.2569 114.49 89.803C114.49 88.3491 115.669 87.1705 117.122 87.1705C118.576 87.1705 119.755 88.3491 119.755 89.803Z"
			fill="#58707F"
		/>
		<path
			d="M151.345 93.313C151.345 94.7668 150.166 95.9455 148.712 95.9455C147.259 95.9455 146.08 94.7668 146.08 93.313C146.08 91.8591 147.259 90.6805 148.712 90.6805C150.166 90.6805 151.345 91.8591 151.345 93.313Z"
			fill="#58707F"
		/>
		<path
			d="M181.18 90.6805C181.18 92.1344 180.001 93.313 178.547 93.313C177.094 93.313 175.915 92.1344 175.915 90.6805C175.915 89.2266 177.094 88.048 178.547 88.048C180.001 88.048 181.18 89.2266 181.18 90.6805Z"
			fill="#58707F"
		/>
		<path
			d="M32.2 112.754C32.2 112.215 32.6365 111.779 33.175 111.779H46.825C47.3635 111.779 47.8 112.215 47.8 112.754C47.8 113.292 47.3635 113.729 46.825 113.729H33.175C32.6365 113.729 32.2 113.292 32.2 112.754Z"
			fill="#58707F"
		/>
		<path
			d="M42.925 118.604C42.925 120.219 41.6154 121.529 40 121.529C38.3846 121.529 37.075 120.219 37.075 118.604C37.075 116.989 38.3846 115.679 40 115.679C41.6154 115.679 42.925 116.989 42.925 118.604Z"
			fill="#58707F"
		/>
		<path
			d="M30.25 124.454C30.25 123.915 30.6865 123.479 31.225 123.479H48.775C49.3135 123.479 49.75 123.915 49.75 124.454C49.75 124.992 49.3135 125.429 48.775 125.429H31.225C30.6865 125.429 30.25 124.992 30.25 124.454Z"
			fill="#58707F"
		/>
		<path
			d="M62.425 112.754C62.425 112.216 62.8615 111.779 63.4 111.779H79C79.5385 111.779 79.975 112.216 79.975 112.754C79.975 113.292 79.5385 113.729 79 113.729H63.4C62.8615 113.729 62.425 113.292 62.425 112.754Z"
			fill="#58707F"
		/>
		<path
			d="M74.125 118.604C74.125 120.219 72.8154 121.529 71.2 121.529C69.5846 121.529 68.275 120.219 68.275 118.604C68.275 116.989 69.5846 115.679 71.2 115.679C72.8154 115.679 74.125 116.989 74.125 118.604Z"
			fill="#58707F"
		/>
		<path
			d="M61.45 124.454C61.45 123.915 61.8865 123.479 62.425 123.479H79.975C80.5135 123.479 80.95 123.915 80.95 124.454C80.95 124.992 80.5135 125.429 79.975 125.429H62.425C61.8865 125.429 61.45 124.992 61.45 124.454Z"
			fill="#58707F"
		/>
		<path
			d="M95.575 112.754C95.575 112.216 96.0115 111.779 96.55 111.779H108.25C108.788 111.779 109.225 112.216 109.225 112.754C109.225 113.292 108.788 113.729 108.25 113.729H96.55C96.0115 113.729 95.575 113.292 95.575 112.754Z"
			fill="#58707F"
		/>
		<path
			d="M105.325 118.604C105.325 120.219 104.015 121.529 102.4 121.529C100.785 121.529 99.475 120.219 99.475 118.604C99.475 116.989 100.785 115.679 102.4 115.679C104.015 115.679 105.325 116.989 105.325 118.604Z"
			fill="#58707F"
		/>
		<path
			d="M92.65 124.454C92.65 123.915 93.0865 123.479 93.625 123.479H111.175C111.713 123.479 112.15 123.915 112.15 124.454C112.15 124.992 111.713 125.429 111.175 125.429H93.625C93.0865 125.429 92.65 124.992 92.65 124.454Z"
			fill="#58707F"
		/>
		<path
			d="M126.775 112.754C126.775 112.216 127.212 111.779 127.75 111.779H139.45C139.988 111.779 140.425 112.216 140.425 112.754C140.425 113.292 139.988 113.729 139.45 113.729H127.75C127.212 113.729 126.775 113.292 126.775 112.754Z"
			fill="#58707F"
		/>
		<path
			d="M136.525 118.604C136.525 120.219 135.215 121.529 133.6 121.529C131.985 121.529 130.675 120.219 130.675 118.604C130.675 116.989 131.985 115.679 133.6 115.679C135.215 115.679 136.525 116.989 136.525 118.604Z"
			fill="#58707F"
		/>
		<path
			d="M123.85 124.454C123.85 123.915 124.287 123.479 124.825 123.479H142.375C142.913 123.479 143.35 123.915 143.35 124.454C143.35 124.992 142.913 125.429 142.375 125.429H124.825C124.287 125.429 123.85 124.992 123.85 124.454Z"
			fill="#58707F"
		/>
		<path
			d="M157.975 112.754C157.975 112.216 158.411 111.779 158.95 111.779H170.65C171.188 111.779 171.625 112.216 171.625 112.754C171.625 113.292 171.188 113.729 170.65 113.729H158.95C158.411 113.729 157.975 113.292 157.975 112.754Z"
			fill="#58707F"
		/>
		<path
			d="M167.725 118.604C167.725 120.219 166.415 121.529 164.8 121.529C163.185 121.529 161.875 120.219 161.875 118.604C161.875 116.989 163.185 115.679 164.8 115.679C166.415 115.679 167.725 116.989 167.725 118.604Z"
			fill="#58707F"
		/>
		<path
			d="M155.05 124.454C155.05 123.915 155.486 123.479 156.025 123.479H173.575C174.113 123.479 174.55 123.915 174.55 124.454C174.55 124.992 174.113 125.429 173.575 125.429H156.025C155.486 125.429 155.05 124.992 155.05 124.454Z"
			fill="#58707F"
		/>
		<path
			d="M189.175 112.754C189.175 112.216 189.611 111.779 190.15 111.779H201.85C202.388 111.779 202.825 112.216 202.825 112.754C202.825 113.292 202.388 113.729 201.85 113.729H190.15C189.611 113.729 189.175 113.292 189.175 112.754Z"
			fill="#58707F"
		/>
		<path
			d="M198.925 118.604C198.925 120.219 197.615 121.529 196 121.529C194.385 121.529 193.075 120.219 193.075 118.604C193.075 116.989 194.385 115.679 196 115.679C197.615 115.679 198.925 116.989 198.925 118.604Z"
			fill="#58707F"
		/>
		<path
			d="M186.25 124.454C186.25 123.915 186.686 123.479 187.225 123.479H204.775C205.313 123.479 205.75 123.915 205.75 124.454C205.75 124.992 205.313 125.429 204.775 125.429H187.225C186.686 125.429 186.25 124.992 186.25 124.454Z"
			fill="#58707F"
		/>
		<path
			d="M53.9173 32.5705H31.5827C30.5705 32.5705 29.75 33.4435 29.75 34.5205C29.75 35.5974 30.5705 36.4705 31.5827 36.4705H53.9173C54.9295 36.4705 55.75 35.5974 55.75 34.5205C55.75 33.4435 54.9295 32.5705 53.9173 32.5705Z"
			fill="#58707F"
		/>
		<path
			d="M85.1174 32.5705H62.7829C61.7707 32.5705 60.9501 33.4435 60.9501 34.5205C60.9501 35.5974 61.7707 36.4705 62.7829 36.4705H85.1174C86.1296 36.4705 86.9501 35.5974 86.9501 34.5205C86.9501 33.4435 86.1296 32.5705 85.1174 32.5705Z"
			fill="#58707F"
		/>
		<path
			d="M68.2856 53.1255H70.5211C70.9046 53.1592 71.291 53.1086 71.6522 52.9771C72.0134 52.8454 72.3403 52.6362 72.61 52.3647C73.081 51.7669 73.3157 51.0199 73.2697 50.2634C73.2999 49.5535 73.065 48.8573 72.61 48.3072C72.351 48.0546 72.0405 47.8593 71.6994 47.7346C71.3582 47.6096 70.9942 47.5579 70.6312 47.5826C69.9484 47.5661 69.2833 47.7983 68.7622 48.2348C68.5236 48.4578 68.3353 48.7277 68.209 49.0273C68.0827 49.3268 68.0216 49.6493 68.0292 49.9736H64.1814C64.1421 49.2272 64.2849 48.482 64.5974 47.8013C64.9099 47.1205 65.383 46.5238 65.9771 46.0611C67.2629 45.0109 68.8906 44.4575 70.5579 44.5035C72.3269 44.4072 74.0713 44.9476 75.4685 46.025C76.0569 46.5521 76.5173 47.2039 76.8156 47.9315C77.1139 48.6591 77.242 49.4437 77.1908 50.2273C77.189 51.1227 76.9075 51.9955 76.3847 52.7269C75.8266 53.5354 75.053 54.175 74.1492 54.5744C75.162 54.9043 76.0374 55.5534 76.6411 56.422C77.2316 57.2606 77.5396 58.2622 77.5206 59.2839C77.5639 60.117 77.4072 60.9485 77.0632 61.7103C76.7192 62.4721 76.198 63.1427 75.5418 63.6673C74.0962 64.7664 72.3069 65.3304 70.4846 65.2614C68.7945 65.3161 67.1373 64.7913 65.7937 63.776C65.1385 63.2875 64.6198 62.642 64.2862 61.9005C63.9529 61.1589 63.8159 60.3458 63.8882 59.5376H67.5528C67.5399 59.896 67.6053 60.253 67.7443 60.5844C67.8836 60.9156 68.0931 61.2134 68.3589 61.4576C68.9157 61.9672 69.6528 62.2403 70.4113 62.2184C70.808 62.2435 71.206 62.1857 71.5786 62.0482C71.9512 61.9108 72.2901 61.6972 72.5735 61.4213C72.8517 61.1482 73.0676 60.8193 73.2066 60.4571C73.3456 60.0947 73.4047 59.7069 73.3796 59.3202C73.4478 58.9037 73.4156 58.4773 73.2855 58.0754C73.1556 57.6737 72.9314 57.3079 72.6315 57.0077C72.3315 56.7078 71.9642 56.4819 71.5593 56.3487C71.1542 56.2153 70.7233 56.1784 70.3012 56.2409H68.066L68.2856 53.1255Z"
			fill="#58707F"
		/>
		<path
			d="M93.682 64.9714H80.2328V62.3269L86.6093 55.2988C87.3614 54.4496 88.0244 53.5272 88.5883 52.5457C88.9417 51.9111 89.1423 51.2044 89.1745 50.4808C89.1971 49.7216 88.9508 48.9785 88.4782 48.3797C88.2471 48.1072 87.9539 47.8927 87.6226 47.7542C87.2914 47.6158 86.9314 47.5569 86.5727 47.5826C86.1725 47.5529 85.7709 47.6238 85.4059 47.7884C85.0406 47.9531 84.7236 48.2062 84.4839 48.5245C83.9991 49.2814 83.7564 50.1651 83.7876 51.0605H79.9396C79.8987 50.21 80.0337 49.3602 80.336 48.5629C80.6387 47.7656 81.1021 47.0376 81.6987 46.4234C82.3339 45.7789 83.0996 45.2746 83.9461 44.9439C84.7923 44.6129 85.7001 44.4628 86.6093 44.5033C88.3638 44.4039 90.0877 44.9895 91.41 46.1335C91.9937 46.695 92.4495 47.3735 92.7465 48.1232C93.0436 48.8728 93.1752 49.6768 93.1323 50.4808C93.1552 51.6718 92.8239 52.8433 92.1796 53.85C91.1959 55.2919 90.1057 56.6601 88.9181 57.9435L85.2535 61.856H93.682V64.9714Z"
			fill="#58707F"
		/>
		<path
			d="M97.0042 46.0889C96.9837 45.683 97.1139 45.2836 97.3704 44.966C97.5045 44.821 97.669 44.7068 97.8525 44.6316C98.036 44.5565 98.234 44.5223 98.4324 44.5311C98.6364 44.5193 98.8407 44.5522 99.0306 44.6274C99.2204 44.7025 99.3912 44.818 99.5309 44.966C99.7874 45.2836 99.9174 45.683 99.8971 46.0889C99.921 46.4955 99.7904 46.8959 99.5309 47.2119C99.3968 47.3569 99.2323 47.4711 99.0488 47.5463C98.8653 47.6214 98.6674 47.6556 98.4689 47.6467C98.2649 47.6586 98.0606 47.6258 97.8708 47.5507C97.6809 47.4756 97.5101 47.3599 97.3704 47.2119C97.1109 46.8959 96.9804 46.4955 97.0042 46.0889ZM97.8099 46.0889C97.7597 46.3034 97.7597 46.5265 97.8099 46.741C97.8634 46.8258 97.9397 46.8944 98.0302 46.9392C98.1204 46.9839 98.2218 47.0031 98.3224 46.9947C98.4132 47.0027 98.5044 46.9827 98.583 46.9371C98.6618 46.8917 98.7244 46.8231 98.7619 46.741C98.8914 46.5485 98.9555 46.3201 98.9449 46.0889C98.9492 45.9021 98.9117 45.7164 98.8351 45.5456C98.791 45.4605 98.7221 45.3907 98.6369 45.3455C98.552 45.3001 98.455 45.2815 98.3592 45.2919C98.2684 45.2839 98.1772 45.3041 98.0986 45.3495C98.0198 45.3949 97.9572 45.4635 97.9197 45.5456C97.8 45.7425 97.7367 45.968 97.7367 46.1976L97.8099 46.0889Z"
			fill="#58707F"
		/>
		<path
			d="M106.165 49.2403C106.184 49.5736 106.131 49.9069 106.011 50.2189C105.891 50.5309 105.707 50.8146 105.469 51.0517C104.902 51.507 104.184 51.7392 103.454 51.7039C103.065 51.7286 102.675 51.6666 102.313 51.5222C101.952 51.378 101.628 51.1553 101.365 50.8706C101.092 50.5936 100.88 50.2641 100.741 49.9027C100.603 49.5413 100.54 49.1555 100.559 48.7694V47.3929C100.525 46.6195 100.801 45.8643 101.328 45.2918C101.896 44.8 102.625 44.5289 103.38 44.5289C104.135 44.5289 104.864 44.8 105.432 45.2918C105.685 45.5198 105.881 45.8009 106.008 46.1146C106.135 46.4283 106.189 46.766 106.165 47.1031H104.773C104.798 46.7134 104.681 46.3278 104.443 46.0162C104.301 45.8862 104.133 45.7868 103.95 45.7243C103.767 45.662 103.573 45.638 103.38 45.654C103.2 45.681 103.027 45.7469 102.875 45.8469C102.723 45.9472 102.596 46.0791 102.501 46.2336C102.239 46.6309 102.11 47.1002 102.134 47.574V48.9505C102.104 49.4305 102.247 49.9055 102.537 50.2909C102.663 50.4513 102.824 50.5805 103.008 50.6685C103.193 50.7566 103.395 50.8009 103.6 50.7982C103.782 50.8157 103.966 50.792 104.137 50.7293C104.308 50.6666 104.463 50.5662 104.59 50.4359C104.835 50.1421 104.954 49.7647 104.92 49.3854L106.165 49.2403Z"
			fill="#58707F"
		/>
		<path
			d="M97.0043 59.1249C96.9836 58.7228 97.1148 58.3272 97.3731 58.0126C97.508 57.869 97.6738 57.756 97.8586 57.6815C98.0434 57.6071 98.2428 57.5732 98.4427 57.5821C98.6483 57.5703 98.854 57.6028 99.0453 57.6772C99.2365 57.7517 99.4086 57.8662 99.5491 58.0126C99.8074 58.3272 99.9386 58.7228 99.918 59.1249C99.9421 59.5275 99.8105 59.9243 99.5491 60.2372C99.4142 60.3809 99.2484 60.4939 99.0636 60.5683C98.8788 60.6427 98.6794 60.6767 98.4795 60.6678C98.2739 60.6796 98.0682 60.6471 97.8769 60.5726C97.6857 60.4982 97.5137 60.3837 97.3731 60.2372C97.1117 59.9243 96.9801 59.5275 97.0043 59.1249ZM97.8157 59.1249C97.7652 59.3374 97.7652 59.5583 97.8157 59.7708C97.8696 59.8548 97.9464 59.9228 98.0375 59.9671C98.1286 60.0114 98.2305 60.0304 98.332 60.022C98.4235 60.0299 98.5152 60.01 98.5945 59.965C98.6738 59.92 98.7367 59.8521 98.7746 59.7708C98.9052 59.5801 98.9698 59.3538 98.959 59.1249C98.9634 58.9398 98.9256 58.756 98.8484 58.5867C98.8041 58.5025 98.7345 58.4333 98.6488 58.3885C98.5632 58.3436 98.4656 58.3252 98.3689 58.3356C98.2775 58.3276 98.1857 58.3475 98.1064 58.3925C98.0271 58.4375 97.9642 58.5054 97.9263 58.5867C97.8058 58.7818 97.7421 59.005 97.7419 59.2326L97.8157 59.1249Z"
			fill="#58707F"
		/>
		<path
			d="M105.302 61.7778H102.461V64.7559H101.04V57.5797H105.942V58.692H102.461V60.6655H105.444L105.302 61.7778Z"
			fill="#58707F"
		/>
		<path
			d="M59.7134 58.9442C59.7121 60.6408 59.038 62.2674 57.8388 63.4675C56.6397 64.6675 55.0135 65.3428 53.3171 65.3454H36.9024C34.9889 65.2968 33.1702 64.5027 31.834 63.1322C30.4978 61.7618 29.75 59.9234 29.75 58.0092C29.75 56.0952 30.4978 54.2569 31.834 52.8861C33.1702 51.5157 34.9889 50.7215 36.9024 50.6731H37.105C37.4453 49.3086 38.1899 48.079 39.2411 47.1449C40.2921 46.2109 41.6009 45.616 42.9958 45.4384C44.3906 45.2607 45.8067 45.5085 47.0583 46.1492C48.31 46.7899 49.3389 47.7937 50.0105 49.0292C50.358 48.9483 50.7135 48.9072 51.0703 48.9067C52.2049 48.9126 53.2984 49.3327 54.145 50.0883C54.9915 50.8437 55.5329 51.8825 55.6674 53.0092C56.8569 53.4819 57.8777 54.2996 58.5988 55.3572C59.3197 56.4148 59.708 57.6643 59.7134 58.9442Z"
			fill="#58707F"
		/>
	</svg>
);
// horizontal preset image
export const HorizontalPresetOne = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 172 : 119 }
		height={ isPopup ? 104 : 72 }
		fill="none"
		viewBox="0 0 119 72"
	>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 0.519 }
			fill="#fff"
			rx={ 1.557 }
		/>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 0.519 }
			stroke="#8796A1"
			strokeWidth={ 1.038 }
			rx={ 1.557 }
		/>
		<rect
			width={ 107.238 }
			height={ 61.299 }
			x={ 5.881 }
			y={ 5.327 }
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 1.813 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 59.5 }
			y={ 10.278 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 6.476 }
			height={ 1.619 }
			x={ 68.134 }
			y={ 10.278 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 59.5 }
			y={ 15 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 12.952 }
			height={ 1.619 }
			x={ 68.134 }
			y={ 15 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 59.5 }
			y={ 19.723 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 8.634 }
			height={ 1.619 }
			x={ 68.135 }
			y={ 19.723 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 59.5 }
			y={ 24.444 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 68.135 }
			y={ 24.444 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 59.5 }
			y={ 29.166 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 11.872 }
			height={ 1.619 }
			x={ 68.135 }
			y={ 29.166 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 86.482 }
			y={ 10.278 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 6.476 }
			height={ 1.619 }
			x={ 95.117 }
			y={ 10.278 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 86.482 }
			y={ 15 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 12.952 }
			height={ 1.619 }
			x={ 95.117 }
			y={ 15 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 86.482 }
			y={ 19.723 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 8.634 }
			height={ 1.619 }
			x={ 95.117 }
			y={ 19.723 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 86.482 }
			y={ 24.444 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 95.117 }
			y={ 24.444 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.619 }
			x={ 86.482 }
			y={ 29.166 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 11.872 }
			height={ 1.619 }
			x={ 95.117 }
			y={ 29.166 }
			fill="#58707F"
			rx={ 0.809 }
		/>
		<rect
			width={ 10.793 }
			height={ 2.159 }
			x={ 10.431 }
			y={ 34.023 }
			fill="#58707F"
			rx={ 1.079 }
		/>
		<rect
			width={ 10.793 }
			height={ 2.159 }
			x={ 23.383 }
			y={ 34.023 }
			fill="#ABB6BD"
			rx={ 1.079 }
		/>
		<rect
			width={ 10.793 }
			height={ 2.159 }
			x={ 36.334 }
			y={ 34.023 }
			fill="#ABB6BD"
			rx={ 1.079 }
		/>
		<path
			fill="#58707F"
			fillRule="evenodd"
			d="M10.431 42.828s9.223-1.29 13.877-1.04c2.974.16 9.867 2.814 16.85 2.775 6.978-.038 11.855-2.896 18.833-2.974 5.819-.064 10.041 1.87 15.86 1.983 6.624.128 10.224-1.385 16.85-1.487 5.856-.09 14.867 1.983 14.867 1.983v3.072c0 .935 0 1.402-.29 1.692-.29.29-.758.29-1.692.29H12.414c-.935 0-1.402 0-1.692-.29-.29-.29-.29-.757-.29-1.692v-4.312Z"
			clipRule="evenodd"
		/>
		<path
			fill="#DEE2E5"
			fillRule="evenodd"
			d="M10.431 43.51s9.223-1.292 13.877-1.041c3.12.167 9.867 2.813 16.85 2.775 6.978-.038 11.47-2.836 18.833-2.974 5.432-.101 10.041 1.87 15.86 1.983 6.624.128 10.224-1.385 16.85-1.487 5.856-.09 14.867 1.982 14.867 1.982v5.056H10.431v-6.295Z"
			clipRule="evenodd"
		/>
		<circle cx={ 24.516 } cy={ 42.151 } r={ 1.457 } fill="#58707F" />
		<circle cx={ 42.001 } cy={ 44.87 } r={ 1.457 } fill="#58707F" />
		<circle cx={ 58.514 } cy={ 41.956 } r={ 1.457 } fill="#58707F" />
		<circle cx={ 75.999 } cy={ 43.899 } r={ 1.457 } fill="#58707F" />
		<circle cx={ 92.512 } cy={ 42.442 } r={ 1.457 } fill="#58707F" />
		<rect
			width={ 8.634 }
			height={ 1.079 }
			x={ 11.51 }
			y={ 54.121 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<path
			fill="#58707F"
			d="M17.446 57.898a1.619 1.619 0 1 1-3.237 0 1.619 1.619 0 0 1 3.237 0Z"
		/>
		<rect
			width={ 10.793 }
			height={ 1.079 }
			x={ 10.431 }
			y={ 60.597 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<rect
			width={ 9.714 }
			height={ 1.079 }
			x={ 28.24 }
			y={ 54.121 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<path
			fill="#58707F"
			d="M34.715 57.898a1.619 1.619 0 1 1-3.237 0 1.619 1.619 0 0 1 3.237 0Z"
		/>
		<rect
			width={ 10.793 }
			height={ 1.079 }
			x={ 27.7 }
			y={ 60.597 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.079 }
			x={ 46.588 }
			y={ 54.121 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<path
			fill="#58707F"
			d="M51.984 57.898a1.619 1.619 0 1 1-3.238 0 1.619 1.619 0 0 1 3.238 0Z"
		/>
		<rect
			width={ 10.793 }
			height={ 1.079 }
			x={ 44.969 }
			y={ 60.597 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.079 }
			x={ 63.857 }
			y={ 54.121 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<path
			fill="#58707F"
			d="M69.253 57.898a1.619 1.619 0 1 1-3.238 0 1.619 1.619 0 0 1 3.238 0Z"
		/>
		<rect
			width={ 10.793 }
			height={ 1.079 }
			x={ 62.238 }
			y={ 60.597 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.079 }
			x={ 81.126 }
			y={ 54.121 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<path
			fill="#58707F"
			d="M86.522 57.898a1.619 1.619 0 1 1-3.238 0 1.619 1.619 0 0 1 3.238 0Z"
		/>
		<rect
			width={ 10.793 }
			height={ 1.079 }
			x={ 79.506 }
			y={ 60.597 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<rect
			width={ 7.555 }
			height={ 1.079 }
			x={ 98.394 }
			y={ 54.121 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<path
			fill="#58707F"
			d="M103.791 57.898a1.619 1.619 0 1 1-3.238 0 1.619 1.619 0 0 1 3.238 0Z"
		/>
		<rect
			width={ 10.793 }
			height={ 1.079 }
			x={ 96.775 }
			y={ 60.597 }
			fill="#58707F"
			rx={ 0.54 }
		/>
		<path
			fill="#58707F"
			d="M24.308 10.278H11.945c-.56 0-1.014.483-1.014 1.08 0 .596.454 1.079 1.014 1.079h12.363c.56 0 1.014-.483 1.014-1.08 0-.595-.454-1.079-1.014-1.079ZM41.577 10.278H29.215c-.56 0-1.015.483-1.015 1.08 0 .596.454 1.079 1.015 1.079h12.362c.56 0 1.014-.483 1.014-1.08 0-.595-.454-1.079-1.014-1.079ZM32.26 21.656h1.238a1.457 1.457 0 0 0 1.156-.42c.26-.332.39-.745.365-1.164a1.592 1.592 0 0 0-.365-1.083 1.42 1.42 0 0 0-1.096-.4c-.377-.01-.746.119-1.034.36a1.282 1.282 0 0 0-.406.963h-2.13a2.56 2.56 0 0 1 .23-1.203c.174-.377.436-.707.765-.963a3.842 3.842 0 0 1 2.535-.862 4.089 4.089 0 0 1 2.718.842c.326.292.58.653.745 1.055.166.403.236.837.208 1.271a2.387 2.387 0 0 1-.446 1.384 2.953 2.953 0 0 1-1.237 1.022c.56.183 1.045.542 1.379 1.023.327.464.497 1.018.487 1.584.024.46-.063.921-.254 1.343a2.93 2.93 0 0 1-.842 1.083c-.8.608-1.79.92-2.799.882a4.088 4.088 0 0 1-2.596-.822 2.652 2.652 0 0 1-.834-1.038 2.62 2.62 0 0 1-.22-1.308h2.028a1.372 1.372 0 0 0 .446 1.063c.308.282.716.433 1.136.421a1.58 1.58 0 0 0 1.197-.441 1.502 1.502 0 0 0 .446-1.163 1.466 1.466 0 0 0-.414-1.28 1.503 1.503 0 0 0-1.29-.424h-1.237l.121-1.725ZM46.317 28.213h-7.444v-1.464l3.53-3.89a9.24 9.24 0 0 0 1.095-1.524c.195-.35.306-.742.324-1.143a1.79 1.79 0 0 0-.386-1.163 1.255 1.255 0 0 0-1.054-.44 1.332 1.332 0 0 0-1.156.52 2.444 2.444 0 0 0-.386 1.404h-2.13a3.434 3.434 0 0 1 .974-2.566 3.607 3.607 0 0 1 2.718-1.063 3.74 3.74 0 0 1 2.657.902 3.094 3.094 0 0 1 .953 2.406 3.34 3.34 0 0 1-.527 1.865 19.598 19.598 0 0 1-1.805 2.266l-2.028 2.165h4.665v1.725ZM48.156 17.761a.916.916 0 0 1 .203-.622.752.752 0 0 1 .587-.24.777.777 0 0 1 .608.24.916.916 0 0 1 .203.622.896.896 0 0 1-.203.622.75.75 0 0 1-.587.24.778.778 0 0 1-.608-.24.896.896 0 0 1-.203-.622Zm.446 0a.791.791 0 0 0 0 .36.302.302 0 0 0 .283.141.244.244 0 0 0 .244-.14.597.597 0 0 0 .101-.361.695.695 0 0 0-.06-.3.261.261 0 0 0-.264-.141.246.246 0 0 0-.243.14.695.695 0 0 0-.102.361l.04-.06ZM53.227 19.505a1.309 1.309 0 0 1-.386 1.003c-.314.252-.711.38-1.115.36a1.453 1.453 0 0 1-1.157-.46 1.562 1.562 0 0 1-.446-1.164v-.761a1.613 1.613 0 0 1 .426-1.163 1.735 1.735 0 0 1 2.272 0 1.242 1.242 0 0 1 .406 1.002h-.771a.896.896 0 0 0-.183-.601.775.775 0 0 0-.588-.2.694.694 0 0 0-.487.32c-.145.22-.216.48-.203.742v.762c-.017.265.063.528.224.742a.73.73 0 0 0 .588.28.676.676 0 0 0 .547-.2.796.796 0 0 0 .183-.582l.69-.08ZM48.156 24.976a.897.897 0 0 1 .204-.615.755.755 0 0 1 .592-.239.795.795 0 0 1 .612.239.897.897 0 0 1 .205.615.878.878 0 0 1-.205.616.756.756 0 0 1-.592.238.795.795 0 0 1-.612-.238.877.877 0 0 1-.204-.616Zm.449 0a.77.77 0 0 0 0 .358.314.314 0 0 0 .286.139.25.25 0 0 0 .145-.032.24.24 0 0 0 .1-.107.584.584 0 0 0 .102-.358.68.68 0 0 0-.061-.297.262.262 0 0 0-.11-.11.272.272 0 0 0-.156-.03.25.25 0 0 0-.145.032.24.24 0 0 0-.1.107.68.68 0 0 0-.102.358l.041-.06ZM52.749 26.445h-1.573v1.648h-.786v-3.972h2.712v.616h-1.926v1.092h1.651l-.078.616ZM27.515 25.015a3.545 3.545 0 0 1-3.54 3.543H14.89a4.062 4.062 0 0 1 0-8.12h.112a3.863 3.863 0 0 1 7.143-.91c.192-.046.39-.068.587-.069a2.576 2.576 0 0 1 2.544 2.271 3.55 3.55 0 0 1 2.24 3.285Z"
		/>
	</svg>
);
export const HorizontalPresetTwo = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 172 : 119 }
		height={ isPopup ? 104 : 72 }
		fill="none"
		viewBox="0 0 119 72"
	>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 0.519 }
			fill="#fff"
			rx={ 1.557 }
		/>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 0.519 }
			stroke="#8796A1"
			strokeWidth={ 1.038 }
			rx={ 1.557 }
		/>
		<rect
			width={ 107.238 }
			height={ 60.192 }
			x={ 5.381 }
			y={ 5.881 }
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 1.73 }
		/>
		<rect
			width={ 9.686 }
			height={ 1.038 }
			x={ 26.982 }
			y={ 25.011 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<path
			fill="#58707F"
			d="M11.965 19.704h1.183a1.372 1.372 0 0 0 1.077-.39 1.62 1.62 0 0 0 .319-1.077 1.467 1.467 0 0 0-.355-1.03 1.326 1.326 0 0 0-1.017-.378 1.36 1.36 0 0 0-.959.343 1.183 1.183 0 0 0-.402.91H9.835a2.366 2.366 0 0 1 .911-2.046 3.549 3.549 0 0 1 2.367-.804 3.833 3.833 0 0 1 2.496.721 2.732 2.732 0 0 1 .97 2.284c-.005.469-.149.926-.414 1.313a2.839 2.839 0 0 1-1.183.97c.523.17.976.506 1.29.958.325.43.507.952.52 1.49a2.804 2.804 0 0 1-1.065 2.249 4 4 0 0 1-2.614.828 3.904 3.904 0 0 1-2.438-.78 2.531 2.531 0 0 1-.982-2.201h2a1.36 1.36 0 0 0 .414 1.005c.29.263.673.403 1.065.39.412.017.815-.127 1.124-.402a1.48 1.48 0 0 0 .402-1.088 1.645 1.645 0 0 0-.402-1.183 1.692 1.692 0 0 0-1.183-.379h-1.184l.036-1.703ZM25.388 26.048h-7.064v-1.405l3.352-3.724a8.648 8.648 0 0 0 1.033-1.442c.188-.338.29-.717.3-1.105a1.646 1.646 0 0 0-.348-1.105 1.2 1.2 0 0 0-.997-.432 1.274 1.274 0 0 0-1.093.504c-.269.396-.4.869-.373 1.346H18.18a3.314 3.314 0 0 1 .913-2.463 3.401 3.401 0 0 1 2.583-.997 3.604 3.604 0 0 1 2.51.853 3.014 3.014 0 0 1 .901 2.198 3.244 3.244 0 0 1-.516 1.79 17.3 17.3 0 0 1-1.694 2.162l-1.85 2.078h4.36v1.742Z"
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 9.693 }
			y={ 28.882 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 19.379 }
			y={ 28.882 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M26.291 15.804a.704.704 0 0 1 .114-.42.43.43 0 0 1 .15-.125.363.363 0 0 1 .18-.037.372.372 0 0 1 .187.036c.06.028.112.07.156.126.08.119.12.268.114.42a.688.688 0 0 1-.114.42.43.43 0 0 1-.15.124.364.364 0 0 1-.18.038.372.372 0 0 1-.187-.036.44.44 0 0 1-.156-.127.688.688 0 0 1-.114-.42Zm.251 0a.64.64 0 0 0 0 .243c.017.032.04.058.069.074.028.017.06.024.09.021a.12.12 0 0 0 .082-.021.157.157 0 0 0 .055-.074.465.465 0 0 0 .057-.243.55.55 0 0 0-.034-.203.165.165 0 0 0-.062-.075.129.129 0 0 0-.086-.02.12.12 0 0 0-.081.021.156.156 0 0 0-.056.074.542.542 0 0 0-.057.243l.023-.04ZM29.14 16.981c.006.125-.01.25-.048.366a.93.93 0 0 1-.168.311.832.832 0 0 1-.627.244.696.696 0 0 1-.354-.068.823.823 0 0 1-.295-.244 1.1 1.1 0 0 1-.194-.361 1.236 1.236 0 0 1-.057-.424v-.514c-.01-.29.075-.571.24-.785a.886.886 0 0 1 .637-.285c.235 0 .462.101.639.285a.86.86 0 0 1 .178.307c.04.117.057.244.05.37h-.434a.692.692 0 0 0-.102-.407.425.425 0 0 0-.153-.109.37.37 0 0 0-.178-.026.353.353 0 0 0-.157.072.436.436 0 0 0-.116.145.96.96 0 0 0-.114.5v.515c-.01.18.035.357.125.5.04.06.09.109.147.142.057.033.12.05.184.048a.322.322 0 0 0 .167-.025.379.379 0 0 0 .14-.11.612.612 0 0 0 .103-.393l.387-.054Z"
		/>
		<rect
			width={ 0.346 }
			height={ 2.767 }
			x={ 30.526 }
			y={ 15.221 }
			fill="#58707F"
			rx={ 0.173 }
		/>
		<path
			fill="#58707F"
			d="M32.256 15.804a.704.704 0 0 1 .114-.42.43.43 0 0 1 .15-.125.363.363 0 0 1 .18-.037.372.372 0 0 1 .187.036.44.44 0 0 1 .155.126c.08.119.12.268.114.42a.688.688 0 0 1-.114.42.43.43 0 0 1-.15.124.364.364 0 0 1-.18.038.372.372 0 0 1-.186-.036.44.44 0 0 1-.156-.127.688.688 0 0 1-.114-.42Zm.25 0a.64.64 0 0 0 0 .243c.018.032.041.058.07.074.028.017.06.024.09.021a.12.12 0 0 0 .082-.021.156.156 0 0 0 .055-.074.465.465 0 0 0 .057-.243.554.554 0 0 0-.034-.203.165.165 0 0 0-.062-.075.129.129 0 0 0-.086-.02.12.12 0 0 0-.081.021.156.156 0 0 0-.056.074.544.544 0 0 0-.057.243l.023-.04ZM34.82 16.804h-.878v1.124h-.44V15.22h1.515v.42h-1.075v.744h.922l-.044.42ZM12.454 11.07a1.384 1.384 0 1 1-2.768 0 1.384 1.384 0 0 1 2.768 0Z"
		/>
		<rect
			width={ 13.837 }
			height={ 1.384 }
			x={ 13.837 }
			y={ 10.378 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.384 }
			x={ 32.518 }
			y={ 10.378 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M57.81 23.828a2.893 2.893 0 0 1-2.889 2.89H47.51a3.314 3.314 0 0 1 0-6.625h.091a3.152 3.152 0 0 1 5.828-.742 2.102 2.102 0 0 1 2.555 1.797 2.898 2.898 0 0 1 1.827 2.68Z"
		/>
		<rect
			width={ 17.988 }
			height={ 1.384 }
			x={ 42.204 }
			y={ 28.851 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 37.36 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 40.819 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 28.366 }
			y={ 37.36 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 28.366 }
			y={ 40.819 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 47.046 }
			y={ 37.36 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 47.046 }
			y={ 40.819 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 47.393 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 50.852 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 28.366 }
			y={ 47.393 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 28.366 }
			y={ 50.852 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 47.046 }
			y={ 47.393 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 47.046 }
			y={ 50.852 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 57.425 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 60.884 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 28.366 }
			y={ 57.425 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 28.366 }
			y={ 60.884 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 47.046 }
			y={ 57.425 }
			fill="#B2BCC3"
			rx={ 0.692 }
		/>
		<rect
			width={ 13.145 }
			height={ 1.384 }
			x={ 47.046 }
			y={ 60.884 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 14.529 }
			height={ 2.076 }
			x={ 66.61 }
			y={ 9.687 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 12.454 }
			height={ 2.076 }
			x={ 97.052 }
			y={ 9.687 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 11.07 }
			height={ 1.384 }
			x={ 66.61 }
			y={ 17.297 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M90.826 17.989a2.076 2.076 0 1 0-4.152 0 2.076 2.076 0 0 0 4.151 0Z"
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 95.668 }
			y={ 17.297 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 17.297 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 11.831 }
			height={ 1.384 }
			x={ 66.61 }
			y={ 24.331 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M90.826 25.023a2.076 2.076 0 1 0-4.152 0 2.076 2.076 0 0 0 4.151 0Z"
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 95.668 }
			y={ 24.331 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 24.331 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 11.07 }
			height={ 1.384 }
			x={ 66.61 }
			y={ 31.364 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M90.826 32.056a2.076 2.076 0 1 0-4.152 0 2.076 2.076 0 0 0 4.151 0Z"
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 95.668 }
			y={ 31.364 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 31.364 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 11.07 }
			height={ 1.384 }
			x={ 66.61 }
			y={ 38.398 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M90.826 39.09a2.076 2.076 0 1 0-4.152 0 2.076 2.076 0 0 0 4.151 0Z"
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 95.668 }
			y={ 38.398 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 38.398 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 11.07 }
			height={ 1.384 }
			x={ 66.61 }
			y={ 45.433 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M90.826 46.124a2.076 2.076 0 1 0-4.152 0 2.076 2.076 0 0 0 4.151 0Z"
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 95.668 }
			y={ 45.433 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 45.433 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 11.07 }
			height={ 1.384 }
			x={ 66.61 }
			y={ 52.467 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M90.826 53.159a2.076 2.076 0 1 0-4.152 0 2.076 2.076 0 0 0 4.151 0Z"
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 95.668 }
			y={ 52.467 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 52.467 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 11.07 }
			height={ 1.384 }
			x={ 66.61 }
			y={ 59.5 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M90.826 60.192a2.076 2.076 0 1 0-4.152 0 2.076 2.076 0 0 0 4.151 0Z"
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 95.668 }
			y={ 59.5 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 6.227 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 59.5 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 0.692 }
			height={ 52.581 }
			x={ 111.39 }
			y={ 9.687 }
			fill="#ABB6BD"
			rx={ 0.346 }
		/>
		<rect
			width={ 0.692 }
			height={ 4.843 }
			x={ 111.39 }
			y={ 24.215 }
			fill="#58707F"
			rx={ 0.346 }
		/>
	</svg>
);
export const HorizontalPresetThree = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 172 : 119 }
		height={ isPopup ? 104 : 72 }
		fill="none"
		viewBox="0 0 119 73"
	>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 1.472 }
			fill="#fff"
			rx={ 1.557 }
		/>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 1.472 }
			stroke="#8796A1"
			strokeWidth={ 1.038 }
			rx={ 1.557 }
		/>
		<rect
			width={ 107.238 }
			height={ 15.221 }
			x={ 5.381 }
			y={ 29.689 }
			stroke="#58707F"
			strokeWidth={ 0.692 }
			rx={ 1.038 }
		/>
		<path
			fill="#58707F"
			d="M11.954 34.878a1.384 1.384 0 1 0-2.768 0 1.384 1.384 0 0 0 2.768 0Z"
		/>
		<rect
			width={ 15.913 }
			height={ 2.076 }
			x={ 13.337 }
			y={ 33.84 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 11.07 }
			height={ 2.076 }
			x={ 9.186 }
			y={ 39.029 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<path
			fill="#58707F"
			d="M43.179 36.455h1.124a1.304 1.304 0 0 0 1.024-.37c.241-.294.362-.668.338-1.047a1.394 1.394 0 0 0-.338-.979 1.26 1.26 0 0 0-.967-.36 1.35 1.35 0 0 0-.911.327 1.125 1.125 0 0 0-.383.877h-1.912a2.25 2.25 0 0 1 .855-2.025 3.375 3.375 0 0 1 2.25-.765 3.645 3.645 0 0 1 2.384.765 2.6 2.6 0 0 1 .889 2.126 2.25 2.25 0 0 1-.36 1.249 2.7 2.7 0 0 1-1.125.922c.498.161.928.482 1.226.911.313.416.486.92.495 1.44a2.666 2.666 0 0 1-.967 2.171c-.71.548-1.59.826-2.486.788a3.712 3.712 0 0 1-2.317-.743 2.408 2.408 0 0 1-.98-2.114h1.89a1.283 1.283 0 0 0 .394.956c.277.25.64.383 1.013.37a1.463 1.463 0 0 0 1.068-.382 1.406 1.406 0 0 0 .383-1.046 1.52 1.52 0 0 0-.383-1.125 1.563 1.563 0 0 0-1.125-.37h-1.124l.045-1.576ZM55.642 42.339h-6.614v-1.316l3.138-3.488c.368-.419.693-.875.967-1.36a2.25 2.25 0 0 0 .259-1.047 1.54 1.54 0 0 0-.326-1.035 1.125 1.125 0 0 0-.934-.405 1.191 1.191 0 0 0-1.023.473c-.252.37-.375.813-.35 1.26h-1.867a3.071 3.071 0 0 1 .855-2.25 3.196 3.196 0 0 1 2.419-.945 3.285 3.285 0 0 1 2.35.81 2.78 2.78 0 0 1 .845 2.092 3.038 3.038 0 0 1-.484 1.676 16.2 16.2 0 0 1-1.586 2.025l-1.732 1.923h4.083v1.587ZM57.13 33.087a.803.803 0 0 1 .13-.479.49.49 0 0 1 .171-.142.414.414 0 0 1 .206-.043.423.423 0 0 1 .212.04.501.501 0 0 1 .178.145.803.803 0 0 1 .13.479.785.785 0 0 1-.13.479.491.491 0 0 1-.171.142.415.415 0 0 1-.206.043.424.424 0 0 1-.212-.04.501.501 0 0 1-.178-.145.785.785 0 0 1-.13-.479Zm.286 0a.73.73 0 0 0 0 .278.212.212 0 0 0 .078.084c.032.02.068.028.104.024a.136.136 0 0 0 .093-.024.179.179 0 0 0 .063-.084.53.53 0 0 0 .065-.278.63.63 0 0 0-.039-.232.19.19 0 0 0-.07-.085.147.147 0 0 0-.1-.023.137.137 0 0 0-.092.025.179.179 0 0 0-.063.083.62.62 0 0 0-.065.278l.026-.046ZM60.38 34.43c.006.142-.012.285-.055.418a1.058 1.058 0 0 1-.192.355.949.949 0 0 1-.715.278.793.793 0 0 1-.405-.078.94.94 0 0 1-.336-.277 1.253 1.253 0 0 1-.221-.413 1.412 1.412 0 0 1-.065-.483v-.587c-.012-.33.086-.652.273-.896.201-.21.46-.325.728-.325.268 0 .526.115.728.325.09.097.16.217.204.35.045.135.064.279.056.422h-.494a.79.79 0 0 0-.117-.463.487.487 0 0 0-.175-.124.421.421 0 0 0-.202-.03.403.403 0 0 0-.18.082.497.497 0 0 0-.132.165c-.093.169-.139.369-.13.571v.587c-.011.204.04.407.143.571a.494.494 0 0 0 .167.161.407.407 0 0 0 .21.056.367.367 0 0 0 .19-.03.43.43 0 0 0 .16-.125.7.7 0 0 0 .118-.448l.442-.061ZM57.13 39.665a.803.803 0 0 1 .13-.479.491.491 0 0 1 .171-.142.414.414 0 0 1 .206-.043.424.424 0 0 1 .212.041.501.501 0 0 1 .178.144.803.803 0 0 1 .13.48.785.785 0 0 1-.13.478.49.49 0 0 1-.171.142.415.415 0 0 1-.206.043.423.423 0 0 1-.212-.04.501.501 0 0 1-.178-.145.785.785 0 0 1-.13-.479Zm.286 0a.73.73 0 0 0 0 .278.212.212 0 0 0 .078.085c.032.019.068.027.104.023a.136.136 0 0 0 .093-.024.179.179 0 0 0 .063-.084.53.53 0 0 0 .065-.278.63.63 0 0 0-.039-.232.19.19 0 0 0-.07-.085.147.147 0 0 0-.1-.023.137.137 0 0 0-.092.025.179.179 0 0 0-.063.083.62.62 0 0 0-.065.278l.026-.046ZM60.055 40.807h-1.002v1.282h-.5V39h1.727v.479h-1.227v.85h1.052l-.05.478ZM76.68 39.272a2.893 2.893 0 0 1-2.889 2.89H66.38a3.314 3.314 0 0 1 0-6.626h.092a3.152 3.152 0 0 1 5.827-.742 2.101 2.101 0 0 1 2.555 1.797 2.897 2.897 0 0 1 1.827 2.68Z"
		/>
		<rect
			width={ 20.064 }
			height={ 2.076 }
			x={ 88.75 }
			y={ 33.84 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 11.07 }
			height={ 2.076 }
			x={ 88.75 }
			y={ 38.683 }
			fill="#58707F"
			rx={ 1.038 }
		/>
	</svg>
);
export const HorizontalPresetFour = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 172 : 119 }
		height={ isPopup ? 104 : 72 }
		fill="none"
		viewBox="0 0 119 73"
	>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 1.472 }
			fill="#fff"
			rx={ 1.557 }
		/>
		<rect
			width={ 117.962 }
			height={ 70.916 }
			x={ 0.519 }
			y={ 1.472 }
			stroke="#8796A1"
			strokeWidth={ 1.038 }
			rx={ 1.557 }
		/>
		<path
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.692 }
			d="M7.802 6.834h102.396c.662 0 1.123.001 1.471.048.339.045.518.128.646.256.128.127.211.307.257.645.047.349.047.81.047 1.473v55.349c0 .662 0 1.124-.047 1.472-.046.338-.13.517-.257.645-.128.127-.307.211-.646.257-.348.046-.809.047-1.471.047H7.802c-.662 0-1.124 0-1.472-.047-.339-.046-.518-.13-.646-.257-.127-.128-.21-.307-.256-.645-.047-.348-.048-.81-.048-1.472V9.255c0-.661.001-1.123.048-1.472.046-.338.128-.518.256-.645.128-.128.307-.21.646-.256.348-.047.81-.048 1.472-.048Z"
		/>
		<rect
			width={ 40.82 }
			height={ 3.459 }
			x={ 9.686 }
			y={ 10.64 }
			fill="#58707F"
			rx={ 1.384 }
		/>
		<path
			fill="#fff"
			d="M14.53 12.369a1.038 1.038 0 1 1-2.076 0 1.038 1.038 0 0 1 2.075 0Z"
		/>
		<rect
			width={ 13.837 }
			height={ 1.038 }
			x={ 15.913 }
			y={ 11.85 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.038 }
			x={ 40.82 }
			y={ 11.851 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<path
			fill="#58707F"
			d="M26.722 22.595h1.124a1.306 1.306 0 0 0 1.024-.371c.241-.294.362-.668.338-1.046a1.395 1.395 0 0 0-.338-.979 1.26 1.26 0 0 0-.967-.36 1.35 1.35 0 0 0-.911.326 1.125 1.125 0 0 0-.383.878h-1.912a2.249 2.249 0 0 1 .855-2.025 3.374 3.374 0 0 1 2.25-.765 3.644 3.644 0 0 1 2.384.765 2.599 2.599 0 0 1 .889 2.126 2.25 2.25 0 0 1-.36 1.248 2.7 2.7 0 0 1-1.125.923c.498.161.928.481 1.226.911.313.416.486.92.495 1.44a2.666 2.666 0 0 1-.967 2.17c-.71.548-1.59.827-2.486.788a3.712 3.712 0 0 1-2.317-.742 2.407 2.407 0 0 1-.98-2.115h1.89a1.281 1.281 0 0 0 .394.956c.277.25.64.384 1.013.372a1.462 1.462 0 0 0 1.068-.383 1.405 1.405 0 0 0 .383-1.046 1.52 1.52 0 0 0-.383-1.125 1.564 1.564 0 0 0-1.124-.371h-1.125l.045-1.575ZM39.185 28.477H32.57v-1.316l3.138-3.487c.368-.42.693-.875.967-1.361a2.25 2.25 0 0 0 .259-1.046c.02-.373-.096-.741-.326-1.035a1.125 1.125 0 0 0-.934-.405 1.194 1.194 0 0 0-1.023.472c-.252.37-.375.813-.35 1.26h-1.867a3.072 3.072 0 0 1 .855-2.25 3.194 3.194 0 0 1 2.419-.944 3.285 3.285 0 0 1 2.35.81 2.779 2.779 0 0 1 .845 2.092 3.036 3.036 0 0 1-.484 1.676 16.19 16.19 0 0 1-1.586 2.025L35.1 26.89h4.084v1.586ZM40.673 19.226a.802.802 0 0 1 .13-.48.49.49 0 0 1 .171-.142.414.414 0 0 1 .206-.042.424.424 0 0 1 .212.04.5.5 0 0 1 .178.145.803.803 0 0 1 .13.479.785.785 0 0 1-.13.478.489.489 0 0 1-.171.143.414.414 0 0 1-.206.043.425.425 0 0 1-.212-.041.5.5 0 0 1-.178-.145.785.785 0 0 1-.13-.478Zm.286 0a.73.73 0 0 0 0 .278.212.212 0 0 0 .078.084c.032.02.068.027.104.024a.137.137 0 0 0 .092-.025.178.178 0 0 0 .064-.083.53.53 0 0 0 .065-.278.629.629 0 0 0-.04-.232.188.188 0 0 0-.07-.085.147.147 0 0 0-.098-.023.136.136 0 0 0-.093.024.178.178 0 0 0-.063.084.62.62 0 0 0-.065.278l.026-.046ZM43.923 20.57c.007.141-.012.283-.054.416a1.059 1.059 0 0 1-.193.355.95.95 0 0 1-.715.278.793.793 0 0 1-.404-.077.938.938 0 0 1-.337-.278 1.252 1.252 0 0 1-.221-.412 1.412 1.412 0 0 1-.065-.484v-.586c-.012-.33.086-.652.273-.896.202-.21.46-.325.728-.325.268 0 .527.115.728.325.09.097.16.217.205.35.045.134.064.278.055.422h-.494a.789.789 0 0 0-.117-.463.486.486 0 0 0-.174-.125.421.421 0 0 0-.203-.03.404.404 0 0 0-.179.082.496.496 0 0 0-.133.165c-.093.17-.138.37-.13.572v.587c-.01.204.04.407.143.571a.493.493 0 0 0 .167.161.406.406 0 0 0 .21.055.365.365 0 0 0 .19-.03.43.43 0 0 0 .161-.124.698.698 0 0 0 .117-.448l.442-.062ZM40.673 25.804a.802.802 0 0 1 .13-.479.49.49 0 0 1 .171-.142.415.415 0 0 1 .206-.043.424.424 0 0 1 .212.04.502.502 0 0 1 .178.145.803.803 0 0 1 .13.479.785.785 0 0 1-.13.479.491.491 0 0 1-.171.142.415.415 0 0 1-.206.043.424.424 0 0 1-.212-.041.5.5 0 0 1-.178-.144.785.785 0 0 1-.13-.48Zm.286 0a.73.73 0 0 0 0 .278.212.212 0 0 0 .078.084.17.17 0 0 0 .104.024.136.136 0 0 0 .092-.025.178.178 0 0 0 .064-.083.53.53 0 0 0 .065-.278.629.629 0 0 0-.04-.232.189.189 0 0 0-.07-.085.147.147 0 0 0-.098-.023.136.136 0 0 0-.093.024.178.178 0 0 0-.063.084.62.62 0 0 0-.065.278l.026-.046ZM43.598 26.946h-1.002v1.281h-.5V25.14h1.727v.478h-1.227v.85h1.052l-.05.479ZM23.216 25.68a2.892 2.892 0 0 1-2.888 2.891h-7.412a3.314 3.314 0 0 1 0-6.625h.091a3.152 3.152 0 0 1 5.828-.743A2.101 2.101 0 0 1 21.389 23a2.897 2.897 0 0 1 1.827 2.68Z"
		/>
		<rect
			width={ 24.907 }
			height={ 1.384 }
			x={ 9.686 }
			y={ 30.703 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 4.151 }
			height={ 1.038 }
			x={ 46.355 }
			y={ 27.244 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 4.151 }
			height={ 1.038 }
			x={ 51.889 }
			y={ 27.244 }
			fill="#58707F"
			rx={ 0.519 }
		/>
		<rect
			width={ 21.794 }
			height={ 7.61 }
			x={ 9.686 }
			y={ 36.238 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<path
			fill="#fff"
			d="M15.74 40.043a1.73 1.73 0 1 1-3.46 0 1.73 1.73 0 0 1 3.46 0Z"
		/>
		<rect
			width={ 11.07 }
			height={ 1.038 }
			x={ 17.815 }
			y={ 38.486 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.038 }
			x={ 17.815 }
			y={ 40.735 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 21.794 }
			height={ 7.61 }
			x={ 33.555 }
			y={ 36.238 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<path
			fill="#fff"
			d="M39.609 40.043a1.73 1.73 0 1 1-3.46 0 1.73 1.73 0 0 1 3.46 0Z"
		/>
		<rect
			width={ 11.07 }
			height={ 1.038 }
			x={ 41.685 }
			y={ 38.486 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.038 }
			x={ 41.685 }
			y={ 40.735 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 21.794 }
			height={ 7.61 }
			x={ 9.686 }
			y={ 45.924 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<path
			fill="#fff"
			d="M15.74 49.73a1.73 1.73 0 1 1-3.46 0 1.73 1.73 0 0 1 3.46 0Z"
		/>
		<rect
			width={ 11.07 }
			height={ 1.038 }
			x={ 17.815 }
			y={ 48.173 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.038 }
			x={ 17.815 }
			y={ 50.422 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 21.794 }
			height={ 7.61 }
			x={ 33.555 }
			y={ 45.924 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<path
			fill="#fff"
			d="M39.61 49.73a1.73 1.73 0 1 1-3.46 0 1.73 1.73 0 0 1 3.46 0Z"
		/>
		<rect
			width={ 11.07 }
			height={ 1.038 }
			x={ 41.685 }
			y={ 48.173 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.038 }
			x={ 41.685 }
			y={ 50.422 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 21.794 }
			height={ 7.61 }
			x={ 9.686 }
			y={ 55.61 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<path
			fill="#fff"
			d="M15.74 59.415a1.73 1.73 0 1 1-3.46 0 1.73 1.73 0 0 1 3.46 0Z"
		/>
		<rect
			width={ 11.07 }
			height={ 1.038 }
			x={ 17.815 }
			y={ 57.858 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.038 }
			x={ 17.815 }
			y={ 60.107 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 21.794 }
			height={ 7.61 }
			x={ 33.555 }
			y={ 55.61 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<path
			fill="#fff"
			d="M39.609 59.415a1.73 1.73 0 1 1-3.46 0 1.73 1.73 0 0 1 3.46 0Z"
		/>
		<rect
			width={ 11.07 }
			height={ 1.038 }
			x={ 41.685 }
			y={ 57.858 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 6.919 }
			height={ 1.038 }
			x={ 41.685 }
			y={ 60.107 }
			fill="#fff"
			rx={ 0.519 }
		/>
		<rect
			width={ 19.372 }
			height={ 2.076 }
			x={ 61.768 }
			y={ 36.284 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 13.837 }
			height={ 2.076 }
			x={ 94.977 }
			y={ 36.284 }
			fill="#58707F"
			rx={ 1.038 }
		/>
		<rect
			width={ 10.378 }
			height={ 9.686 }
			x={ 61.768 }
			y={ 41.819 }
			fill="#58707F"
			rx={ 1.384 }
		/>
		<path
			fill="#fff"
			d="M69.378 46.663a2.422 2.422 0 1 1-4.843 0 2.422 2.422 0 0 1 4.843 0Z"
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 74.913 }
			y={ 44.587 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 12.454 }
			height={ 1.384 }
			x={ 74.913 }
			y={ 47.355 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 0.692 }
			height={ 4.151 }
			x={ 100.512 }
			y={ 44.587 }
			fill="#58707F"
			rx={ 0.346 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 44.587 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 47.355 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 10.378 }
			height={ 9.686 }
			x={ 61.768 }
			y={ 53.581 }
			fill="#58707F"
			rx={ 1.384 }
		/>
		<path
			fill="#fff"
			d="M69.378 58.424a2.422 2.422 0 1 1-4.843 0 2.422 2.422 0 0 1 4.843 0Z"
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 74.913 }
			y={ 56.349 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 12.454 }
			height={ 1.384 }
			x={ 74.913 }
			y={ 59.116 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 0.692 }
			height={ 4.151 }
			x={ 100.512 }
			y={ 56.349 }
			fill="#58707F"
			rx={ 0.346 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 56.349 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 5.535 }
			height={ 1.384 }
			x={ 103.279 }
			y={ 59.116 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 62.959 }
			y={ 27.936 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 10.378 }
			height={ 1.384 }
			x={ 62.959 }
			y={ 30.703 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 8.302 }
			height={ 1.384 }
			x={ 101.012 }
			y={ 27.936 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<rect
			width={ 10.378 }
			height={ 1.384 }
			x={ 98.936 }
			y={ 30.703 }
			fill="#58707F"
			rx={ 0.692 }
		/>
		<path
			fill="#58707F"
			d="M105.244 27.244c.443 0 .805-.36.779-.802-.24-4.112-2.32-8.015-5.853-10.939-3.763-3.114-8.866-4.863-14.188-4.863-5.32 0-10.424 1.75-14.187 4.863-3.534 2.924-5.613 6.827-5.853 10.94a.767.767 0 0 0 .779.801c.443 0 .8-.36.828-.802.239-3.76 2.148-7.324 5.381-10 3.462-2.864 8.157-4.474 13.052-4.474 4.896 0 9.591 1.61 13.053 4.474 3.232 2.676 5.142 6.24 5.381 10 .028.443.385.802.828.802Z"
		/>
		<g fill="#58707F" clipPath="url(#a)">
			<path d="M93.49 11.254a.506.506 0 0 0 .718 0 .507.507 0 0 0 0-.717l-.718-.717a.507.507 0 1 0-.717.717l.717.717ZM93.316 14.099c0-.28-.227-.461-.507-.461h-1.015c-.28 0-.507.18-.507.46 0 .281.227.462.507.462h1.015c.28 0 .507-.18.507-.461ZM96.36 10.363c.28 0 .461-.228.461-.508V8.84c0-.28-.18-.507-.46-.507-.281 0-.462.227-.462.507v1.015c0 .28.18.508.461.508ZM98.872 11.403c.13 0 .26-.05.358-.149l.718-.717a.507.507 0 1 0-.718-.717l-.717.717a.507.507 0 0 0 .359.866ZM96.36 10.87a2.54 2.54 0 0 0-2.537 2.537 2.54 2.54 0 0 0 2.537 2.537 2.54 2.54 0 0 0 2.537-2.537 2.54 2.54 0 0 0-2.537-2.537ZM93.49 15.559l-.717.717a.507.507 0 1 0 .717.718l.718-.718a.507.507 0 1 0-.718-.717ZM100.927 12.946h-1.015c-.28 0-.507.181-.507.462 0 .28.227.46.507.46h1.015c.28 0 .507-.18.507-.46s-.227-.462-.507-.462ZM96.36 16.451c-.28 0-.461.227-.461.508v1.014c0 .28.18.508.461.508.28 0 .461-.228.461-.508V16.96c0-.28-.18-.508-.46-.508Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M90.826 7.872h11.07v11.07h-11.07z" />
			</clipPath>
		</defs>
	</svg>
);
